<div class="row"
     [ngClass]="{'search-page-layout': layout === 'searchpage', 'search-bar-layout': layout === 'resultspage'}">
  <div class="container d-flex justify-content-center">
    <div class="form-group my-3 input-form-group">
      <div class="input-group"
           matAutocompleteOrigin
           #origin="matAutocompleteOrigin"
      >
        <div
          class="d-flex justify-content-center align-items-center search-bar-custom"
        >
          <input
            type="text"
            [matAutocompleteConnectedTo]="origin"
            matAutocompletePosition="below"
            [matAutocomplete]="auto"
            (input)="getSuggestions()"
            (keydown.enter)="search()"
            [(ngModel)]="data"
            i18n-placeholder="campo di ricerca|Placeholder @@search-page.search-bar.placeholder"
            placeholder="Ricerca un principio attivo, azienda farmaceutica, medicinale, descrizione ATC e codice AIC"
            aria-label="Ricerca un principio attivo, azienda farmaceutica, medicinale, descrizione ATC e codice AIC "
          />

         <!-- <svg *ngIf="layout === 'resultspage'" class="icon d-block me-5" (click)="search()">
            <use href="/assets/icons/sprites.svg#it-search"></use>
          </svg>-->

          <mat-autocomplete
            [ngClass]="{'search-input-autocomplete': layout === 'searchpage', 'result-page-autocomplete': layout === 'resultspage'}"
            #auto="matAutocomplete"
            (optionSelected)="selectSuggestion($event)"
          >
            <mat-option
              *ngFor="let x of suggests"
              [value]="x"
            >
              {{ x }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
    </div>
    <div class="custom-align-button" *ngIf="layout === 'searchpage'">
      <button class="search-button" id="basic-addon2" (click)="search()"
              i18n="Significato icona ricerca|Pagina ricerca @@search-page.search-bar.button-text" aria-label="Cerca">
        Cerca
      </button>
    </div>
    <div class="custom-align-button search-page-layout" *ngIf="layout === 'resultspage'">
      <button class="search-button" id="basic-addon2" (click)="search()"
              i18n="Significato icona ricerca|Pagina ricerca @@search-page.search-bar.button-text" aria-label="Cerca">
        Cerca
      </button>
    </div>
  </div>
</div>
